<template>
  <div class="selected-treatments">
    <div class="selected-treatments__header">
      <h4
        id="selected-treatments-title"
        class="selected-treatments__title"
      >
        {{ tc('spaSoft.step1.selectedTreatments.title') }}
      </h4>
      <h5 class="selected-treatments__subtitle">
        {{ tc('spaSoft.step1.selectedTreatments.titleRight') }}
      </h5>
    </div>
    <transition-group
      name="selected-treatments-list"
      tag="ol"
      class="selected-treatments__list"
    >
      <SelectedTreatmentCard
        v-for="treatment in currentGuestData.selectedTreatments"
        :key="treatment.uuid"
        :treatment="treatment"
        class="selected-treatments__card"
      />
    </transition-group>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Tracking from '@mixins/tracking'
  import SelectedTreatmentCard from './components/selected-treatment-card.vue'

  export default {
    name: 'SelectedTreatmentsList',
    components: {
      SelectedTreatmentCard
    },
    mixins: [Tracking],
    inject: ['currentGuestNumber'],
    computed: {
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('spaSoft', ['guestsSelectedData']),
      currentGuestData() {
        return this.guestsSelectedData[this.currentGuestNumber]
      },
    },
  }
</script>
<style scoped>
.selected-treatments-list-move {
  transition: transform .5s;
}
</style>
